module.exports = __webpack_public_path__ + "static/media/publish-videos-images-mobile-es.f7e39e63.png";